<div class="set-list">
  <mat-chip-listbox
    (resized)="breakpoints()"
    hideSingleSelectionIndicator
    (change)="change($event.value)"
    id="list"
    >
    @for (chip of chipsList; track chip) {
      <mat-chip-option
        class="chip-option"
        [value]="chip.key"
        [selected]="chip.key == selectedChipKey"
        [disabled]="loading"
        >
        <div style="display: flex; align-items: center">
          {{ chip.value }}
          <mat-icon style="scale: 0.7">{{ chip.icon }}</mat-icon>
        </div>
      </mat-chip-option>
    }
    @if (chips.length > columns) {
      <mat-chip-option
        class="chip-option"
        style="--width-var: 85px"
        [selectable]="false"
        [disabled]="loading"
        [matMenuTriggerFor]="seeMore"
        [value]="null"
        >
        +{{ this.chips.length - columns }} More
      </mat-chip-option>
    }
  </mat-chip-listbox>

  <mat-menu #seeMore="matMenu">
    <div class="see-more-menu">
      <mat-chip-listbox
        (resized)="breakpoints()"
        hideSingleSelectionIndicator
        (change)="change($event.value)"
        >
        @for (chip of chipsSubList; track chip) {
          <mat-chip-option
            [value]="chip.key"
            class="chip-option"
            style="margin-left: 12px"
            [selected]="chip.key == selectedChipKey"
            [disabled]="loading"
            >
            <div style="display: flex; align-items: center">
              {{ chip.value }}
              <mat-icon style="scale: 0.7">{{ chip.icon }}</mat-icon>
            </div>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  </mat-menu>
</div>
